/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Suggestions_DescriptionInputs */



/**
* | output |
* | --- |
* | "Show follow-up question suggestions below the assistant's replies in chats" |
*
* @param {Preferences_Suggestions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_suggestions_description = /** @type {((inputs?: Preferences_Suggestions_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Suggestions_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschläge für Folgefragen unter den Antworten des Assistenten in Chats anzeigen")
	return /** @type {LocalizedString} */ ("Show follow-up question suggestions below the assistant's replies in chats")
});